<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('permissions') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-treeview
            v-if="role"
            v-model="permissions"
            :items="items"
            selectable
            selected-color="primary"
            item-key="to"
            open-on-click
          >
            <template
              v-slot:prepend="{ item }"
            >
              <v-icon>
                {{ item.icon }}
              </v-icon>
              {{ $t(item.title) }}
            </template>
          </v-treeview>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo( 'roleList' )"
            >
              {{ $t('roleList') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  import menu from '../../../../menu.json'
  export default {
    name: 'Product',
    components: {
    },
    mixins: [General],
    props: ['roleProp'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      permissions: [],
      id: null,
      tag: null,
      search: null,
      valid: null,
      message: null,
      alertType: null,
      items: menu,
      name: null,
      type: null,
      role: null,
      status: 'active',
      group: null,
      caseSensitive: false,
      loading: false,
    }),
    computed: {
    },
    watch: {
      roleProp () {
        this.role = this.roleProp
        this.show()
      },
    },
    activated () {
      // this.show()
    },
    beforeMount () {
      if (!this.roleProp) {
        this.goTo('roleList')
      }
      this.render = true
      this.items = JSON.parse(JSON.stringify(this.$store.state.menu))
      var filtered = []
      this.items.map(function (value, i) {
        filtered.push(value)
        var children = [...value.children]
        filtered[i].children = []
        children.filter(function (item) {
          if (item.to !== 'divider') {
            filtered[i].children.push(item)
          }
        })
      })
    },
    mounted () {
      this.role = this.roleProp
      this.show()
    },
    methods: {
      filter () {
        var app = this
        this.items = this.$store.state.menu
        this.items.map(function (value, key) {
          var title = app.$t(value.title).toLowerCase()
          var search = app.search.toLowerCase()
          if (!title.match(search)) {
            value.bookmark = true
          } else {
            value.bookmark = false
          }
        })
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'role/' + this.roleProp.id + '/edit', {
          params: {
            id: this.$route.params.id,
            permission: 'active',
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              // app.id = res.id
              // app.name = res.name
              app.permissions = res
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'role/' + this.role.id, this.$data, {
          params: { setPermissions: true },
        })
          .then(res => {
            res = res.data
            if (res.update === 'yes') {
              app.$store.commit('SET_PERMISSIONS', app.permissions)
            }
            app.goTo('roleList')
            this.getPermissions()
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
